import { useSelector } from "src/store";
import { selectCurrentWorkspaceId } from "src/store/app";

import { skipToken } from "@reduxjs/toolkit/query";

import { useGetClientFeaturesQuery, useGetClientQuery, useGetClientsQuery } from "./index";
import { GetClientsParams } from "./rtkClient";

type ClientsQueryParams = Omit<GetClientsParams, "workspaceId">;

function useCurrentWorkspaceClients(params: ClientsQueryParams) {
    const workspaceId = useSelector(selectCurrentWorkspaceId);
    return useGetClientsQuery(workspaceId === null ? skipToken : { ...params, workspaceId });
}

function useCurrentWorkspaceClient(clientId: number | undefined) {
    const workspaceId = useSelector(selectCurrentWorkspaceId);
    return useGetClientQuery(workspaceId === null || !clientId ? skipToken : { workspaceId, clientId });
}

function useCurrentWorkspaceClientFeatures(clientId: number | undefined) {
    const workspaceId = useSelector(selectCurrentWorkspaceId);
    return useGetClientFeaturesQuery(workspaceId === null || !clientId ? skipToken : { workspaceId, clientId });
}

export { useCurrentWorkspaceClient, useCurrentWorkspaceClientFeatures, useCurrentWorkspaceClients };
